module.exports = __webpack_public_path__ + "static/media/itech.83cf2f82.jpg";